
import React from 'react'
import icon from './svgs/line.svg'
import { BaseIcon } from './_base'

export const LineVectorIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,height:'30px',width:'150px',...sx}} />
    )
}
